function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import isString from 'lodash.isstring';
import isFunction from 'lodash.isfunction';
import sortBy from 'lodash.sortby';
import { createBrowserHistory } from 'history';
import * as StyledComps from './StyledComps';
import PageRender from './PageRender';
import helpers from './helpers';
var viewerAllRoot = document.body;
var viewerAllRootAppended = !!document.querySelector('.emag-issue-viewers-wrapper');
var viewerRoot = viewerAllRootAppended ? document.querySelector('.emag-issue-viewers-wrapper') : document.createElement('div');

if (!viewerRoot.classList.add('emag-issue-viewers-wrapper')) {
  viewerRoot.classList.add('emag-issue-viewers-wrapper');
}

if (!viewerAllRootAppended) {
  viewerAllRoot.appendChild(viewerRoot);
}

var IssueViewerContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(IssueViewerContainer, _React$Component);

  var _super = _createSuper(IssueViewerContainer);

  function IssueViewerContainer(props) {
    var _this;

    _classCallCheck(this, IssueViewerContainer);

    _this = _super.call(this, props);
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(IssueViewerContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      viewerRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      viewerRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/ReactDOM.createPortal(this.props.children, this.el);
    }
  }]);

  return IssueViewerContainer;
}(React.Component);

var IssueViewer = /*#__PURE__*/function (_Component) {
  _inherits(IssueViewer, _Component);

  var _super2 = _createSuper(IssueViewer);

  function IssueViewer(props) {
    var _this2;

    _classCallCheck(this, IssueViewer);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isShowing: false,
      loading: false,
      error: false,
      _mounted: false,
      issue: null,
      bodyOverflow: document.querySelector('body').style.overflow,
      currentPage: _this2.props.startPage,
      showDebug: !!_this2.props.debug
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      var alwaysOpen = _this2.props.alwaysOpen;
      var history = createBrowserHistory({
        getUserConfirmation: function getUserConfirmation(message, callback) {
          var isShowing = _this2.state.isShowing;

          if (isShowing && history.action === 'POP') {
            callback(false);
          } else {
            callback(true);
          }
        }
      });
      _this2.unblockListener = history.block('Are you sure you want to leave this page?');
      _this2.backListener = history.listen(function (location, action) {
        if (action === 'POP') {
          _this2.closeModal();
        }
      });
      _this2._mounted = true;

      if (alwaysOpen) {
        _this2.openModalHandler();
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "componentWillUnmount", function () {
      _this2._mounted = false;
      document.querySelector('body').style.overflow = _this2.state.bodyOverflow ? _this2.state.bodyOverflow : 'auto';

      _this2.unblockListener();

      _this2.backListener();
    });

    _defineProperty(_assertThisInitialized(_this2), "loadIssue", function () {
      var _this2$props = _this2.props,
          entrypoint = _this2$props.entrypoint,
          headers = _this2$props.headers,
          issueId = _this2$props.issueId,
          startPage = _this2$props.startPage;
      var requestOptions = {
        method: 'GET',
        headers: new Headers(isFunction ? headers() : headers),
        mode: 'cors',
        cache: 'default'
      };
      var request = new Request("".concat(entrypoint).concat(issueId, "?full=1"), requestOptions);

      _this2.setState({
        loading: true,
        error: false
      });

      fetch(request).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (_this2._mounted) {
          if (json.code !== undefined && (json.code === 401 || json.code === 403)) {
            throw new Error(json.message);
          } else if (json.pages === undefined) {
            throw new Error('Forbidden');
          }

          var currentPage = _this2.state.currentPage;

          if (json.pages) {
            json.pages = sortBy(json.pages, ['position']);

            if (isString(startPage)) {
              var newPage = helpers.getPageIndex(json.pages, startPage);
              currentPage = newPage !== null ? newPage : 0;
            }
          }

          _this2.setState({
            issue: json,
            loading: false,
            error: false,
            currentPage: currentPage
          });

          _this2.handleViewerEvent('open');

          _this2.handleViewerEvent('pageView', {
            pageIndex: currentPage
          });
        }
      })["catch"](function (e) {
        if (_this2._mounted) {
          _this2.setState({
            loading: false,
            error: e.message
          });

          _this2.handleViewerEvent('error', {
            error: e.message
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "getCurrentPage", function () {
      var currentPageForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this2$state = _this2.state,
          currentPage = _this2$state.currentPage,
          issue = _this2$state.issue;

      if (issue) {
        // console.log('getCurrentPage', currentPage, helpers.getIssuePage( issue.pages, currentPage ));
        return helpers.getIssuePage(issue.pages, currentPageForce === null ? currentPage : currentPageForce);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this2), "onPageChange", function (_ref) {
      var pageId = _ref.pageId;
      var issue = _this2.state.issue;
      var page = pageId === 'next' || pageId === 'previous' ? helpers.getIssuePage(issue.pages, pageId === 'next' ? _this2.state.currentPage + 1 : _this2.state.currentPage - 1) : {
        '@id': pageId
      };

      if (page !== null) {
        var newPageIndex = helpers.getPageIndex(issue.pages, page['@id']);

        if (newPageIndex !== null) {
          _this2.setState({
            currentPage: newPageIndex
          });

          _this2.handleViewerEvent('pageView', {
            pageIndex: newPageIndex
          });
        } else {
          _this2.handleViewerEvent('error', {
            error: 'Page Not Found'
          });
        }
      } else {
        _this2.handleViewerEvent('error', {
          error: 'Page Not Found'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "openModalHandler", function () {
      _this2.setState({
        isShowing: true
      });

      document.querySelector('body').style.overflow = 'hidden';

      if (_this2.state.issue === null && !_this2.state.loading) {
        _this2.loadIssue();
      } else {
        _this2.handleViewerEvent('open');

        _this2.handleViewerEvent('pageView');
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "closeModalHandler", function (e) {
      e.preventDefault();

      _this2.closeModal();
    });

    _defineProperty(_assertThisInitialized(_this2), "closeModal", function () {
      var issue = _this2.state.issue;
      var alwaysOpen = _this2.props.alwaysOpen;

      if (!alwaysOpen) {
        _this2.handleViewerEvent('close');

        _this2.setState({
          isShowing: false,
          currentPage: _this2.props.startPage
        });

        document.querySelector('body').style.overflow = _this2.state.bodyOverflow ? _this2.state.bodyOverflow : 'auto';
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "startLoading", function () {
      return _this2.setState({
        loading: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "stopLoading", function () {
      return _this2.setState({
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "toggleDebug", function () {
      return _this2.setState({
        showDebug: !_this2.state.showDebug
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleViewerEvent", function (event, data) {
      var issue = _this2.state.issue;
      var onEvent = _this2.props.onEvent;

      if (onEvent) {
        onEvent(event, _objectSpread({
          issue: issue,
          page: _this2.getCurrentPage(data && data.pageIndex ? data.pageIndex : null)
        }, data));
      }
    });

    _this2.modalRef = /*#__PURE__*/React.createRef();
    return _this2;
  }

  _createClass(IssueViewer, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isShowing = _this$state.isShowing,
          loading = _this$state.loading,
          error = _this$state.error,
          issue = _this$state.issue,
          showDebug = _this$state.showDebug;
      var _this$props = this.props,
          button = _this$props.button,
          errorMessage = _this$props.errorMessage,
          computeRegionStyle = _this$props.computeRegionStyle,
          modalParams = _this$props.modalParams,
          loaderParams = _this$props.loaderParams,
          debug = _this$props.debug,
          extra = _this$props.extra,
          closeLabel = _this$props.closeLabel,
          alwaysOpen = _this$props.alwaysOpen;
      var page = this.getCurrentPage();
      return /*#__PURE__*/React.createElement(Fragment, null, !alwaysOpen ? /*#__PURE__*/React.cloneElement(button, {
        onClick: this.openModalHandler
      }) : null, /*#__PURE__*/React.createElement(IssueViewerContainer, null, isShowing ? /*#__PURE__*/React.createElement(StyledComps.ModalBackDrop, {
        onClick: this.closeModalHandler
      }) : null, /*#__PURE__*/React.createElement(StyledComps.Modal, _extends({
        style: {
          opacity: isShowing ? 1 : 0,
          visibility: isShowing ? 'visible' : 'hidden'
        }
      }, modalParams), !alwaysOpen ? /*#__PURE__*/React.createElement(StyledComps.ModalCloseBtn, {
        onClick: this.closeModalHandler,
        title: closeLabel
      }) : null, debug ? /*#__PURE__*/React.createElement(StyledComps.ModalToggleDebugBtn, {
        onClick: this.toggleDebug,
        active: showDebug
      }) : null, extra ? isFunction(extra) ? extra({
        handleClose: this.closeModalHandler,
        issue: issue
      }) : /*#__PURE__*/React.cloneElement(extra, {
        handleClose: this.closeModalHandler,
        issue: issue
      }) : null, /*#__PURE__*/React.createElement(StyledComps.ModalWrapper, null, loading ? /*#__PURE__*/React.createElement(StyledComps.ModalLoading, loaderParams) : null, error ? errorMessage ? isFunction(errorMessage) ? errorMessage({
        error: error,
        handleClose: this.closeModalHandler
      }) : /*#__PURE__*/React.cloneElement(errorMessage, {
        error: error,
        handleClose: this.closeModalHandler
      }) : /*#__PURE__*/React.createElement("div", null, "ERROR") : null, isShowing && !error && issue ? /*#__PURE__*/React.createElement(StyledComps.ModalBody, {
        ref: this.modalRef
      }, page ? /*#__PURE__*/React.createElement(PageRender, {
        issue: issue,
        page: page,
        onPageChange: this.onPageChange,
        modalRef: this.modalRef,
        startLoading: this.startLoading,
        stopLoading: this.stopLoading,
        computeRegionStyle: computeRegionStyle,
        debug: showDebug,
        handleViewerEvent: this.handleViewerEvent
      }) : null) : null))));
    }
  }]);

  return IssueViewer;
}(Component);

_defineProperty(IssueViewer, "getDerivedStateFromProps", function (props, prevState) {
  if (prevState.issue && props.issueId !== prevState.issue['@id']) {
    return {
      issue: null,
      currentPage: props.startPage
    };
  }

  return {};
});

IssueViewer.propTypes = {
  issueId: PropTypes.string.isRequired,
  startPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onPageChange: PropTypes.func,
  computeRegionStyle: PropTypes.func,
  debug: PropTypes.bool,
  alwaysOpen: PropTypes.bool,
  button: PropTypes.element.isRequired,
  extra: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  errorMessage: PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.element]),
  closeLabel: PropTypes.string
};
IssueViewer.defaultProps = {
  issueId: null,
  startPage: 0,
  onPageChange: null,
  computeRegionStyle: null,
  debug: false,
  alwaysOpen: false,
  closeLabel: "Fermer l'emag"
};
export default IssueViewer;